


















import {Component, Prop, Vue} from 'vue-property-decorator';
import {EventItem} from '@/store/models';
import user from '@/store/modules/user';

@Component
export default class StartCompanyItem extends Vue {
    @Prop() event: EventItem | undefined;

    async gotoItem() {
        if (!this.event) {
            return;
        }
        await user.setActiveExternalUser(null);
        const OrgNr: string = this.event.OrgNr;
        this.$router.push({ name: 'overview', params: { OrgNr } });
    }

    get documentType() {
        if (this.isUpdated) {
            return 'Uppdaterat bolag';
        }
        return 'Hämtat bolag';
    }

    get isUpdated(): boolean {
        if (!this.event) {
            return false;
        }
        return this.event.Updated;
    }
}
